import api from '../../api/api.js'
import utils from '../../utils/utils.js'
import shopaccess from '../../api/moudles/shopaccess.js'
import { Message } from 'element-ui'

import {
  SET_SHOPID_INFO,
  SET_STORAGE_TTP,
  SET_WAREHOUSE_INFO,
  GET_SUCCESSED_DATA,
  SET_SISTEM_ALL_STORE,
  GET_LAZADA_SHOP,
  GET_TTO_CCP,
  DELET_HAS_CLAIM,
  RESET_SECOND_PASSWORD,
  DELET_HAS_CLAIM_ALL
  

} from '../mutation-types'
import { resolve } from 'path'
import { reject } from 'core-js/fn/promise'

const state = () => ({
	shopInfo:JSON.parse(localStorage.getItem('shopIdInfo')) ? JSON.parse(localStorage.getItem('shopIdInfo')) : [],
	warehouse: JSON.parse(localStorage.getItem('warehouse')) ? JSON.parse(localStorage.getItem('warehouse')) : [],
	userInfo: JSON.parse(localStorage.getItem('userInfo')) ? JSON.parse(localStorage.getItem('userInfo')) :  '',
	shophasAuthorization:false,
	Successed:false,
	sistemAllstore:[],
	lazadashopinfo:JSON.parse(localStorage.getItem('lazadashopId')) ? JSON.parse(localStorage.getItem('lazadashopId')) :  '',
	tiktokShops:JSON.parse(localStorage.getItem('userInfo')) ? JSON.parse(localStorage.getItem('userInfo')).tiktokShops :  [],
	temuAuth:JSON.parse(localStorage.getItem('userInfo')) ? JSON.parse(localStorage.getItem('userInfo')).temuAuth :  [],
	allShopSales:[],
	allWarehouseSales:[],
	allStoreCargovalue:0,//所有仓库的货值
	allshipCostAmount:0,//所有仓库的运费成本
	salestotal:0,
	salesquentity:0,
	cost:0,
	shopSales:[],//每一间店铺的销售情况，对象形式存入数组
	warehouseSales:[],
	toComfirmClaimdata:[],
	toComfirmClaimtotal:0,
	Claimdata:[],
	Claimtotal:0,
	hasClaimdata:[],
	hasClaimtotal:0,
	claimlist:[],
	claimlisttotal:0,
	Amount01:0,
	Amount02:0,
	Amount03:0,
	exportXmlList:[],
	secondPassword:JSON.parse(localStorage.getItem('secondPws')) || false,
	flagTip:0,
	warehouseList:[],
	isParnet:false,
	
})

const getters = {}

const actions = {
	checkPartner({state},payload){
		state.isParnet=payload
		console.log('isParnet',state.isParnet)
	},
	//新建私有仓帐号
	getSellerPrivateStore({state,commit},payload){
		shopaccess
		.getSellerPrivateStore(payload)
		.then(res => {
			if(res.code === 200) {
				console.log('私有仓帐号',res.data)
				res.data.forEach(p => {
					state.warehouseList.push(p)
				})
			    commit(SET_WAREHOUSE_INFO,state.warehouseList)
				
			}
		})
	},
	//新建私有仓帐号
	createPrivateStore({state},payload){
		shopaccess
		.createPrivateStore(payload)
		.then(res => {
			if(res.code === 200) {
				console.log('新建私有仓',res)
				Message({
					message: '创建私有仓成功!',
					type: 'success'
				})
				
			}else if(res.code === 500) {
				console.log('新建私有仓',res)
				Message({
					message: res.msg,
					type: 'error'
				})
			}
		})
	},
	//修改二次密码
	resetSecondyPassword({state},payload){
		shopaccess
		.resetSecondyPassword(payload)
		.then(res => {
			if(res.code ===200) {
				
				Message({
					message: "二次密码修改成功！",
					type: 'success'
				})
			}else{
				Message({
					message: res.msg,
					type: 'error'
				})
			}
		})
	},
	//验证二次密码
	verifySecondyPassword({state},payload){
		shopaccess
		.verifySecondyPassword(payload)
		.then(res => {
			if(res.code ===200) {
				console.log('验证二次密码',res.data)
				if(res.data){
					Message({
						message: '验证成功',
						type: 'success'
					})
				}else{
					Message({
						message: '密码错误',
						type: 'error'
					})
				}
				
				state.secondPassword=res.data
				localStorage.setItem('secondPws',JSON.stringify(res.data))
			}
		})
	},
	//放弃索赔
	giveUpClaim({commit},payload){
		shopaccess
		.giveUpClaim(payload)
		.then(res => {
			if(res.code ===200) {
				console.log('放弃索赔',res.data)
				Message({
					message: '订单已放弃索赔',
					type: 'success'
				})
				setTimeout(() => {
					commit(DELET_HAS_CLAIM,payload.ordersn)
				},1000)
				
			}
		})
	},
	//确认索赔
	auditReturn({state,commit},payload) {
		const p =new Promise((resolve) => {
			shopaccess
			.auditReturn(payload)
			.then(res => {
				if(res.code ===200) {
					resolve(res.code)
					console.log('已确认索赔',res.data)
					Message({
						message: '提交成功,待卖家联系平台客服!',
						type: 'success'
					})
				}
			})
		})

		return p
	},
	//获取商店可索赔的订单
	getReturnOrder({state},payload) {
		shopaccess
		.getReturnOrder(payload)
		.then(res => {
			if(res.code ===200) {
				
				state.claimlist=res.data.orders
				state.claimlisttotal=res.data.count
				
				console.log('可索赔的订单',res.data)
				if(payload.exportXml === 3) {
					    state.flagTip=2
					    state.exportXmlList=[]
						state.exportXmlList=res.data.orders
						console.log('全部导出xml',state.exportXmlList)
					
				}else{
					state.flagTip=1
					if(payload.type == 0) {//待确认索赔
						state.toComfirmClaimdata=res.data.orders
						state.toComfirmClaimtotal=res.data.count
						state.Amount01=res.data.amount ? res.data.amount : 0
					}else if(payload.type == 1){//待索赔
						state.Claimdata=res.data.orders
						state.Claimtotal=res.data.count
						state.Amount02=res.data.amount ? res.data.amount : 0
					}else if(payload.type == 2){
						state.hasClaimdata=res.data.orders
						state.hasClaimtotal=res.data.count
						state.Amount03=res.data.amount ? res.data.amount : 0
					}
					
				}
				
				
			}
		})
	},
	//获取帐号下的仓库
	getUserStock({commit,dispatch},payload) {
		shopaccess
		.getUserStock(payload)
		.then(res => {
			if(res.code ===200) {
				console.log('获取帐号下的仓库',res.datas)
				
			}
		})
	},
	
	//卖家帐号绑定店铺
	getLockShopID({commit,dispatch},payload) {	
		const p=new Promise((resolve) => {
			api
			.getLockShopID(payload)
			.then(res => {
				resolve(res)
			})

		})
		return p
		
	},
	//授权shopee店铺,跳转至授权页面
	getShopAuthorization(){
		shopaccess
		.getShopAuthorization()
		.then(res => {
			if(res.code === 200) {
				console.log(res.data)
				console.log(location.host+'/index')
				// window.open(res.data)
			}
		})
	},
	
	//获取已绑定的商店
	getUserInfo({commit},payload) {
		shopaccess
		.getUserInfo(payload)
		.then(res => {
			if(res.code === 200) {
				console.log('res.data',res.data)
				
				
				commit(SET_SHOPID_INFO,res.data)
				commit(SET_STORAGE_TTP,res.data)
			}
		})
	},
	//创建仓库
	createWarehouse({state},payload) {
		const p=new Promise((resolve,reject) => {
			api
			.createWarehouse(payload)
			.then(res => {
				// state.warehouse
				resolve(res)
			})
		})

		return p
		
	},
	//获取卖家账号已经绑定的所有仓库
	searchWarehouse({state,commit,dispatch},payload) {
		api
		.searchWarehouse(payload)
		.then(res => {
			if(res.code === 200) {
				console.log(payload)
				console.log('公有仓',res.data)
				state.warehouseList=res.data
			    commit(SET_WAREHOUSE_INFO,state.warehouseList)
				// dispatch('getSellerPrivateStore',{userId:payload})
			}
		})
	},
	//获取仓库
	bindWarehouse({commit},payload) {
		api
		.bindWarehouse(payload)
		.then(res => {
			if(res.code === 200) {
				console.log(res.data)
				alert('获取成功')
				commit()
			}
		})
	},
	//获取仓库帐号所有的仓库
	getAllstore({commit},payload) {
		shopaccess
		.getAllstore(payload)
		.then(res => {
			if(res.code === 200){
				console.log(res.data)
				commit(SET_WAREHOUSE_INFO,res.data)
			}
		})
	},
	//仓库帐号下删除仓库
	deleteWarehouse({commit},payload) {
		shopaccess
		.deleteWarehouse(payload)
		.then(res => {
			if(res.code === 200){
				console.log('删除仓库',res.data)
				Message({
					message:'成功删除仓库！',
					type:'success'
				})
				setTimeout(() => {
					location.replace('/index')
				},500)
			}else{
				Message({
					message:res.msg,
					type:'success'
				})
			}
		})
	},
	//获取系统内所有的仓库
	getAllstoreALL({commit},payload) {
		shopaccess
		.getAllstoreALL(payload)
		.then(res => {
			if(res.code === 200){
				console.log(res.data)
				// res.data.forEach((p,index) => {
				// 	if(p.storeName.indexOf('测品仓') > -1 ){
				// 		res.data.splice(index,1)
				// 	}
					
				// })
				commit(SET_SISTEM_ALL_STORE,res.data)
			}
		})
	},
	//卖家帐号绑定仓库
	sellerBindStore({commit},payload) {
		shopaccess
		.sellerBindStore(payload.payload)
		.then(res => {
			if(res.code === 200){
				Message({
					message:payload.text,
					type:'success'
				})
				// commit(GET_SUCCESSED_DATA)
			}
		})
	},
	//卖家帐号解绑店铺
	unboundShop({commit}, payload) {
		shopaccess
		.unboundShop(payload.payload) 
		.then(res => {
			if(res.code === 200) {
				Message({
					message:payload.text,
					type:'success'
				})
				// commit(GET_SUCCESSED_DATA)
			}
		})
	},
	//卖家帐号解绑仓库
	unboundStore({commit}, payload) {
		console.log(payload)
		shopaccess
		.unboundStore(payload.payload) 
		.then(res => {
			if(res.code === 200) {
				Message({
					message: payload.text,
					type: 'success'
				})
			// commit(GET_SUCCESSED_DATA)
			}
		})
	},
	//获取LAZADA授权网址
	getlazadaAuthorizationUrl({commit}, payload) {
		console.log(payload)
		shopaccess
		.getlazadaAuthorizationUrl(payload) 
		.then(res => {
			if(res.code === 200) {
				Message({
					message: '获取成功',
					type: 'success'
				})
				window.open(res.data)
			  console.log('获取laza授权',res.data)
			}
		})
	},
	
	//获取已经绑定的lazada商店
	getLazadaShop({commit}, payload) {
		shopaccess
		.getLazadaShop(payload) 
		.then(res => {
			if(res.code === 200) {
			   console.log('获取laza店铺',res.data)
			   commit(GET_LAZADA_SHOP,res.data)
			}
		})
	},
	
	//获取商店的销售情况 
	getShopSale({commit,state}, payload) {
		shopaccess
		.getShopSale(payload) 
		.then(res => {
			if(res.code === 200) {
				// state.shopSales=[]
				console.log('商店销售情况',res.data)
				console.log(payload)
				let ttp=0
				let ccp=0
				let oop=0
				res.data.forEach(p => {
					state.salestotal += p.saleroom
					state.salesquentity += p.sales
					state.cost += p.productCost+p.shipCost
					ttp += p.saleroom,
					ccp += p.sales,
					oop += p.productCost+p.shipCost+p.serviceFee
					
				})
				
				
				
				let arr={
					shopId:payload.shopId,
					shopName:payload.shopName,
					sales:ttp,
					saleroom:ccp,
					cost:oop.toFixed(2),
					options:res.data
					
				}
				
			    state.shopSales.push(arr)
				console.log(state.shopSales)
				
				
			   let createTime=res.data.map(p => {
				   
				   return  utils.getCurrnetTime(p.createTime)
			   })
			   let saleroom=res.data.map(p => {
			   				   return p.saleroom
			   })
			   let sales=res.data.map(p => {
			   				   return p.sales
			   })
			  
			   state.allShopSales.push({
				   shopId:payload.shopId,
				   shopName:payload.shopName,
				   option : {
				       tooltip: {
				           trigger: 'axis',
				           axisPointer: {
				               type: 'cross',
				               crossStyle: {
				                   color: '#999'
				               }
				           }
				       },
				       toolbox: {
				           feature: {
				               dataView: {show: true, readOnly: false},
				               magicType: {show: true, type: ['line', 'bar']},
				               restore: {show: true},
				               saveAsImage: {show: true}
				           }
				       },
					   color:['#37A2DA', '#67E0E3',  '#FFDB5C','#FF9F7F',  '#FB7293', '#E062AE',  '#9D96F5', '#8378EA', '#96BFFF'],
				       legend: {
				           data: ['销售量', '销售额']
				       },
				       xAxis: [
				           {
				               type: 'category',
				               data: createTime,
				               axisPointer: {
				                   type: 'shadow'
				               }
				           }
				       ],
				       yAxis: [
				          {
				              type: 'value',
				              name: '销售量',
				              type: 'value'
				          },
				          {
				              type: 'value',
				              name: '销售额',
				             type: 'value'
				          }
				       ],
				       series: [
				           {
				               name: '销售量',
				               type: 'bar',
				               data:sales
				           },
				          
				           {
				               name: '销售额',
				               type: 'line',
				               yAxisIndex: 1,
				               data: saleroom
				           }
				       ]
				   },
			   })
			   console.log(state.allShopSales)
			}
		})
	},
	
	
	getStoreSale({commit,state}, payload) {
		shopaccess
		.getStoreSale(payload) 
		.then(res => {
			if(res.code === 200) {
				
				console.log('仓库销售情况',res.data)
				
				let ttp=0
				let ccp=0
				let oop=0
				res.data.forEach(p => {
					ttp += p.saleroom,
					ccp += p.sales,
					oop += p.cost
					
				})
				
				let arr={
					storeId:payload.storeId,
					storeName:payload.storeName,
					sales:ttp.toFixed(2),
					saleroom:ccp,
					cost:oop.toFixed(2),
					options:res.data
					
				}
				
				state.warehouseSales.push(arr)
				
				console.log(state.warehouseSales)
				
				
				
				
				
				
				let createTime=res.data.map(p => {
								   
								   return  utils.getCurrnetTime(p.createTime)
				})
				let saleroom=res.data.map(p => {
								   return p.saleroom
				})
				let sales=res.data.map(p => {
								   return p.sales
				})
				
				state.allWarehouseSales.push({
					storeId:payload.storeId,
					storeName:payload.storeName,
					option:{
				       tooltip: {
				           trigger: 'axis',
				           axisPointer: {
				               type: 'cross',
				               crossStyle: {
				                   color: '#999'
				               }
				           }
				       },
				       toolbox: {
				           feature: {
				               dataView: {show: true, readOnly: false},
				               magicType: {show: true, type: ['line', 'bar']},
				               restore: {show: true},
				               saveAsImage: {show: true}
				           }
				       },
				       legend: {
				           data: ['销售量', '销售额']
				       },
				       xAxis: [
				           {
				               type: 'category',
				               data: createTime,
				               axisPointer: {
				                   type: 'shadow'
				               }
				           }
				       ],
				       yAxis: [
				          {
				              type: 'value',
				              name: '销售量',
				              type: 'value'
				          },
				          {
				              type: 'value',
				              name: '销售额',
				             type: 'value'
				          }
				       ],
				       series: [
				           {
				               name: '销售量',
				               type: 'bar',
				               data:sales
				           },
				          
				           {
				               name: '销售额',
				               type: 'line',
				               yAxisIndex: 1,
				               data: saleroom
				           }
				       ]
				   },
				})
				
				console.log(state.allWarehouseSales)
				
				
			  
			}
		})
	},
	
	//获取仓库货值
	getCargovalueStore({state}, payload) {
		shopaccess
		.getCargovalueStore(payload) 
		.then(res => {
			if(res.code === 200) {
			   console.log('获取仓库货值',res.data)
			   let ttp=0
			   let ccp=0
			   ttp += res.data.cargoValue
			   ccp += res.data.shipCostAmount
			   state.allStoreCargovalue = ttp
			    state.allshipCostAmount =ccp
			}
		})
	},
	
}

const mutations = {
	[SET_SHOPID_INFO]: (state,data) =>{
		state.shopInfo=data
	},
	[SET_STORAGE_TTP]: (state,data) =>{
		if(data.userId == 'ABH_Int'){
			data.partnerId=28
		}
		if(data.shopeeShops || data.lazadaShops || data.tiktokShops || data.temuAuth){
			console.log(data)
			localStorage.setItem('shophasAuthorization', true)
			state.shopInfo=data.shopeeShops
			state.lazadashopinfo=data.lazadaShops
			state.tiktokShops=data.tiktokShops
			state.temuAuth=data.temuAuth
			console.log(state)
		}else{
			localStorage.setItem('shophasAuthorization', false)
		}
		if(data.userPos=== 'STORE'){
			localStorage.setItem('shophasAuthorization', true)
			
		}
		state.warehouse=data.stores
		state.userInfo=data
		
		localStorage.setItem('userInfo', JSON.stringify(data))
		localStorage.setItem('shopIdInfo', JSON.stringify(data.shopeeShops))
		localStorage.setItem('warehouse', JSON.stringify(data.stores))
		localStorage.setItem('lazadashopId', JSON.stringify(data.lazadaShops))
		localStorage.setItem('temuAuth', JSON.stringify(data.temuAuth))
		location.replace('/index')
		
		
		
	},

	[SET_WAREHOUSE_INFO]: (state,data) =>{
		data.forEach(p => {
			p.checked=false
		})
		state.warehouse=data
		localStorage.setItem('warehouse', JSON.stringify(data))
	},
	[GET_SUCCESSED_DATA]: (state) =>{
		state.Successed=!state.Successed
	},
	[SET_SISTEM_ALL_STORE]: (state,data) =>{
		state.sistemAllstore=data
	},
	[GET_LAZADA_SHOP]: (state,data) =>{
		state.lazadashopinfo=data ? data : []
		localStorage.setItem('lazadashopId', JSON.stringify(data))
	},
	[GET_TTO_CCP]: (state) =>{
		state.salestotal=0
		state.salesquentity=0
		state.cost=0
		state.shopSales=[]
		state.warehouseSales=[]
		
	},
	[DELET_HAS_CLAIM]:(state,data) => {
		console.log(data)
	    console.log(state.toComfirmClaimdata)
		let arr=[]
		arr.push(data)
		if(state.Claimdata.length> 0){
			state.toComfirmClaimdata.forEach((p,index) => {
				arr.forEach(k => {
					if(p.orderId === k) {
						state.toComfirmClaimdata.splice(index,1)
						console.log(state.toComfirmClaimdata)
					}
				})
			})
		}
		
		
		if(state.Claimdata.length> 0) {
			state.Claimdata.forEach((p,index) => {
				arr.forEach(k => {
					if(p.orderId === k) {
						state.Claimdata.splice(index,1)
						console.log(state.Claimdata)
					}
				})
			})
		}
		
		
	},
	[DELET_HAS_CLAIM_ALL]:(state,data) => {

		state.claimlist=[]
		state.shopInfo=data.shopeeShops
		state.lazadashopinfo=data.lazadaShops
		state.warehouse=data.stores
		state.temuAuth=data.temuAuth
		console.log('新增加',state.warehouse)
		
		
	} ,
	[RESET_SECOND_PASSWORD]:(state) => {
		state.secondPassword=false
	}
	
	

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}